import React from 'react'
import {
  Box,
  Text,
  Color,
  FontWeight,
  Display,
  FlexDirection,
  JustifyContent,
  Divider,
} from '@gousto-internal/citrus-react'
import { InfoMessage } from './InfoMessage'

type OrderSummaryProps = {
  deliveryPricing: {
    recipeTotal: string
    discountTotal: string
    surchargeTotal?: string
    percentageOff: string
    finalTotal: string
    deliveryTotal: string
  }
  shouldShowOrderSummary: boolean
  numberOfRecipes: number
}

export const OrderSummary = ({
  deliveryPricing,
  numberOfRecipes,
  shouldShowOrderSummary,
}: OrderSummaryProps) => {
  return (
    <Box style={{ paddingTop: '1rem' }} color={Color.ColdGrey_900}>
      <Text fontWeight={FontWeight.Bold}>Order summary</Text>

      {shouldShowOrderSummary ? (
        <Box
          display={Display.Flex}
          flexDirection={FlexDirection.Column}
          gap={2}
          style={{ paddingTop: '0.5rem' }}
        >
          <Box display={Display.Flex} justifyContent={JustifyContent.SpaceBetween}>
            <Text>Recipes ({numberOfRecipes})</Text>
            <Text>{deliveryPricing.recipeTotal}</Text>
          </Box>

          <Box display={Display.Flex} justifyContent={JustifyContent.SpaceBetween}>
            <Text color={Color.Success_800}>Discount (-{deliveryPricing.percentageOff})</Text>
            <Text color={Color.Success_800}>-{deliveryPricing.discountTotal}</Text>
          </Box>

          <Divider />

          <Box display={Display.Flex} justifyContent={JustifyContent.SpaceBetween}>
            <Text>Delivery cost</Text>
            <Text>{deliveryPricing.deliveryTotal}</Text>
          </Box>

          {deliveryPricing.surchargeTotal && <Divider />}

          {deliveryPricing.surchargeTotal && (
            <Box display={Display.Flex} justifyContent={JustifyContent.SpaceBetween}>
              <Text>Surcharges and/or savings</Text>
              <Text>{deliveryPricing.surchargeTotal}</Text>
            </Box>
          )}
        </Box>
      ) : (
        <InfoMessage text="The price of your box will show once you’ve added 2–5 recipes." />
      )}

      <Box paddingV={2}>
        <Divider />
        <Box display={Display.Flex} justifyContent={JustifyContent.SpaceBetween} paddingV={2}>
          <Text fontWeight={FontWeight.Bold}>Total</Text>
          <Text fontWeight={FontWeight.Bold}>
            {shouldShowOrderSummary ? `${deliveryPricing.finalTotal}` : '£---'}
          </Text>
        </Box>
      </Box>
    </Box>
  )
}
